define(["require", "exports", "./dialogs/signupCoupon", "./facebookApi", "./dialogs/promptSignup"], function (require, exports, signupCoupon_1, facebookApi_1, promptSignup_1) {
    "use strict";
    exports.__esModule = true;
    exports.setupDebugMenuWith = function (items) {
        if (window.location.hostname === 'localhost') {
            var $subMenu = $("<li><a href='./'>Dev</a><ul></ul></li>");
            var $subList_1 = $subMenu.find('ul');
            items.forEach(function (item) {
                var $item = $("<li><a href='.'>" + item.text + "</a></li>");
                $item.on('click', item.onClick);
                $item.appendTo($subList_1);
            });
            $('.topmenu').append($subMenu);
        }
    };
    var mockEmail = 'mockregistered@mock.com';
    exports.setupDebugMenu = function () {
        exports.setupDebugMenuWith([
            {
                text: 'Prompt signup',
                onClick: function (evt) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    promptSignup_1["default"]('Mock prompt sign up dialog', 100, false);
                }
            },
            {
                text: 'Signup coupon',
                onClick: function (evt) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    signupCoupon_1["default"]('abcdefghijklmn', 100, 500, mockEmail);
                }
            },
            {
                text: 'Mock register',
                onClick: function (evt) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    $.ajax({
                        url: "/customer/registerMockUser?email=" + mockEmail,
                        type: 'POST',
                        dataType: 'json'
                    }).then(function (resp) {
                        facebookApi_1.registerShowOnLoadDialog({
                            type: 'signupCoupon',
                            user: resp.user
                        });
                        window.location.href = '/';
                    });
                }
            }
        ]);
    };
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/debugMenu.js
// module id = 92
// module chunks = 0